// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__LqBjX","right":"styles_right__1xT7g"};